var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3785 12.1286L11.0909 15.4161C10.77 15.7371 10.2496 15.7371 9.92863 15.4161L6.64112 12.1286C6.32016 11.8077 6.32016 11.2873 6.64112 10.9663C6.96209 10.6454 7.48247 10.6454 7.80343 10.9663L9.68791 12.8508V3.32871C9.68791 2.8748 10.0559 2.50684 10.5098 2.50684C10.9637 2.50684 11.3317 2.8748 11.3317 3.32871V12.8508L13.2161 10.9663C13.5371 10.6454 14.0575 10.6454 14.3785 10.9663C14.6994 11.2873 14.6994 11.8077 14.3785 12.1286Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.93477 15.2459C3.93477 14.792 3.5668 14.4241 3.11289 14.4241C2.65898 14.4241 2.29102 14.792 2.29102 15.2459V16.4787C2.29102 18.2944 3.76288 19.7663 5.57852 19.7663H15.441C17.2567 19.7663 18.7286 18.2944 18.7286 16.4787V15.2459C18.7286 14.792 18.3606 14.4241 17.9067 14.4241C17.4528 14.4241 17.0848 14.792 17.0848 15.2459V16.4787C17.0848 17.3866 16.3489 18.1225 15.441 18.1225H5.57852C4.6707 18.1225 3.93477 17.3866 3.93477 16.4787V15.2459Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/export-icon.60c1c5af692ca2eda2047e586db2508f.svg";
export { ForwardRef as ReactComponent };